<template>
  <div class="step-wrapper">
      <verification v-show="voucherStep === 'verification'" :default-values="values"
        :on-input-change="onVerificationInputChange" />
      <verification-error v-show="voucherStep === 'verificationError'" />
      <card-type-error v-show="voucherStep === 'cardTypeError'" />
      <voucher v-show="voucherStep === 'voucher'" />
      <voucher-error v-show="voucherStep === 'voucherError'" />
      <reusability-error v-show="voucherStep === 'reusabilityError'" />
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Verification from './steps/Verification.vue';
import VerificationError from './steps/VerificationError.vue';
import Voucher from './steps/Voucher.vue';
import VoucherError from './steps/VoucherError.vue';
import CardTypeError from './steps/CardTypeError.vue';
import ReusabilityError from './steps/ReusabilityError.vue';

export default {
  name: 'voucher-wizard',
  created() {
    if (this.voucher) {
      this.setVoucherWizardStep('voucher');
    } else {
      this.setVoucherWizardStep('verification');
    }
  },
  computed: {
    ...mapState({
      voucherStep: (state) => state.voucher.currentStep,
      loading: (state) => state.voucher.loading,
      voucher: (state) => state.voucher.voucher,
    }),
  },
  methods: {
    ...mapActions({
      setVoucherWizardStep: 'setVoucherWizardStep',
    }),
    onVerificationInputChange(key, value) {
      this.values[key] = value;
    },
  },
  data() {
    return {
      values: {
        isicNumber: null,
        cardholderName: null,
      },
      validationErrors: {},
      verificationError: null,
    };
  },
  components: {
    Verification,
    VerificationError,
    Voucher,
    VoucherError,
    CardTypeError,
    ReusabilityError,
  },
};
</script>
